<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="$props.name || $props.label"
    :rules="$props.rules"
    tag="div"
    :class="{ 'displayflex': displayType == 'displayflex' }"
  >
    <label
      v-if="!!$props.label || $slots.label"
      :for="id"
      :class="{ 'labelWidth': displayType == 'displayflex' }"
    >
      <slot name="label">
        {{ $props.label }}
        <span v-if="$props.required == true" class="text-danger">*</span>
      </slot>
    </label>

    <div>
      <b-input
        v-model="formattedValue"
        v-bind="$attrs"
        v-on="$listeners"
        :id="id"
        :name="$props.name"
        inputmode="decimal"
        autocomplete="off"
        :aria-invalid="!!errors"
        class="base-input"
        :class="{ 'is-invalid': !!errors.length, 'textBoxWidth': displayType == 'displayflex' }"
        @input="onInput"
        @keypress.native="onKeyPress"
        @paste.native="onPaste"
      ></b-input>

      <div v-if="!!errors.length" class="invalid-feedback">
        {{ errors[0] }}
      </div>
    </div>
  </ValidationProvider>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { uniqueId } from 'lodash-es'
import { ValidationProvider } from 'vee-validate'

export default defineComponent({
  name: 'BaseInputCurrency',
  inheritAttrs: false,
  components: {
    ValidationProvider
  },
  props: {
    name: String,
    value: [String, Number],
    label: String,
    rules: String,
    required: Boolean,
    displayType: String
  },
  emits: ['input'],

  setup(props, { emit }) {
    const id = computed(() => `id_${uniqueId('base-input-')}`)

    const formattedValue = computed({
      get() {
        if (
          props.value === null ||
          props.value === undefined ||
          /[^0-9.,$]/.test(props.value)
        ) {
          return ''
        }

        let raw = String(props.value).replace(/,/g, '')
        raw = raw.replace(/\$/g, '')

        const number = parseFloat(raw)

        if (isNaN(number)) {
          return ''
        }

        // if (number === 0) {
        //   return ''
        // }

        return number.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        })
      },

      set(newValue) {
        let rawValue = newValue.replace(/[^\d.]/g, '')
        rawValue = rawValue.replace(/,/g, '')
        rawValue = rawValue.replace(/$/g, '')

        const decimalIndex = rawValue.indexOf('.')
        if (decimalIndex !== -1) {
          rawValue = rawValue.slice(0, decimalIndex + 3)
        }

        emit('input', rawValue)
      }
    })

    const onInput = (event) => {
      let value = event

      if (/[^0-9.,$]/.test(value)) {
        value = ''
      }

      value = value.replace(/[^\d.,$]/g, '')

      emit('input', value)
    }

    /*
     * Prevent alphabets from being typed
     */
    const isAllowedChar = (ch) => /[0-9.,$]/.test(ch)

    const onKeyPress = (e) => {
      if (e.ctrlKey || e.metaKey || e.altKey) return

      const key = e.key

      if (key.length === 1 && !isAllowedChar(key)) {
        e.preventDefault()
      }
    }

    const onPaste = (e) => {
      const text = (e.clipboardData || window.clipboardData).getData('text')

      if (/[^0-9.,$]/.test(text)) {
        e.preventDefault()
      }
    }

    return {
      id,
      formattedValue,
      onInput,
      onKeyPress,
      onPaste
    }
  }
})
</script>

<style scoped>
.displayflex {
  display: flex !important;
}
.labelWidth {
  width: 50%;
}
.textBoxWidth {
  width: 70%;
  margin-left: 20px;
}
</style>